import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { VerticalDatums } from '../../../modules/sources/vertical-datums.enum';
import { tap } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'mee-data-collection-and-scanning',
  templateUrl: './data-collection-and-scanning.component.html',
  styleUrls: ['./data-collection-and-scanning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataCollectionAndScanningComponent implements OnInit {
  gnssControl = new FormControl<VerticalDatums | null>(null);
  private readonly destroyRef = inject(DestroyRef);
  @Output() gnssDatumChange = new EventEmitter<VerticalDatums>();
  @Input() set gnssDatum(datum: VerticalDatums) {
    this.gnssControl.setValue(datum, { emitEvent: false });
  }

  ngOnInit(): void {
    this.initHandlerGnssDatumChange();
  }

  private initHandlerGnssDatumChange(): void {
    this.gnssControl.valueChanges
      .pipe(
        tap(datum => this.gnssDatumChange.emit(datum)),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }
}
